import React from 'react';
import { Drawer, List, useTheme, Hidden } from '@material-ui/core';

import NavItem from '../../../components/nav/NavItem';
import NavItemMobile from '../../../components/nav/NavItemMobile';

import { items } from './items';
import { useStyles } from './styles';

interface IProps {
  drawerVisible: boolean;
  onCloseDrawer: any;
  window?: () => Window;
}

const NavBar: React.FC<IProps> = ({ drawerVisible, onCloseDrawer, window }) => {
  const classes = useStyles();
  const theme = useTheme();
  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <>
      <Hidden smDown implementation="js">
        <aside id="aside" className={classes.drawer}>
          <List component="nav">
            {items.map((item, index) => (
              <NavItem
                key={item.title}
                href={item.href}
                title={item.title}
                icon={item.icon}
                disabled={item.disabled}
                menu={item.menu}
                index={index}
                totalItems={items.length}
                drawerOpen={drawerVisible}
                onCloseDrawer={onCloseDrawer}
              />
            ))}
          </List>
        </aside>
      </Hidden>
      <Drawer
        id="mobile-drawer"
        variant="temporary"
        container={container}
        anchor={theme.direction === 'rtl' ? 'right' : 'left'}
        open={drawerVisible}
        onClose={onCloseDrawer}
        classes={{
          paper: classes.drawerOpen,
        }}
        ModalProps={{
          keepMounted: true,
        }}
      >
        <List component="nav">
          {items.map((item, index) => (
            <NavItemMobile
              key={item.title}
              href={item.href}
              title={item.title}
              icon={item.icon}
              disabled={item.disabled}
              menu={item.menu}
              index={index}
              totalItems={items.length}
              drawerOpen={drawerVisible}
              onCloseDrawer={onCloseDrawer}
            />
          ))}
        </List>
      </Drawer>
    </>
  );
};

export default NavBar;
